import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import PageHero from '../../components/base/PageHero';

export default function CompanyPage() {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "ジュエリーおかやま株式会社",
      "url": siteUrl,
      "logo": `${siteUrl}/logo.png`,
      "description": "岡山市のオーダーメイドジュエリー専門店。2000年創業、地域密着型のジュエリーショップ。",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "北区○○町1-2-3",
        "addressLocality": "岡山市",
        "addressRegion": "岡山県",
        "postalCode": "700-0000",
        "addressCountry": "JP"
      },
      "telephone": "+81-86-012-3456",
      "faxNumber": "+81-86-012-3457",
      "foundingDate": "2000",
      "numberOfEmployees": 5,
      "founder": {
        "@type": "Person",
        "name": "岡山太郎"
      }
    });
    document.head.appendChild(script);
    
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <PageHero
          title="会社概要"
          subtitle="Company Information"
          image="https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/b88dc6dbc3a0e55c9fa53cfbedc302e5.jpeg"
        />

        {/* Company Info Section */}
        <section className="py-20 lg:py-28 bg-white">
          <div className="max-w-[1200px] mx-auto px-6 lg:px-12">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
              {/* Company Details */}
              <div>
                <h2 className="text-3xl md:text-4xl font-serif font-semibold text-brown-600 mb-8">
                  会社情報
                </h2>
                
                <div className="space-y-6">
                  {[
                    { label: '会社名', value: 'ジュエリーおかやま株式会社' },
                    { label: '代表取締役', value: '岡山 太郎' },
                    { label: '所在地', value: '〒700-0000 岡山市北区○○町1-2-3' },
                    { label: '電話番号', value: '086-012-3456' },
                    { label: 'FAX', value: '086-012-3457' },
                    { label: '設立', value: '2000年' },
                    { label: '従業員数', value: '5名' },
                    { label: '営業時間', value: '9:00 〜 18:00' },
                    { label: '定休日', value: '土曜日・祝日' },
                    { label: '事業内容', value: 'ジュエリーの製造・販売、オーダーメイド、リメイク・修理、ブライダルジュエリー' },
                  ].map((item, index) => (
                    <div
                      key={index}
                      className="flex flex-col sm:flex-row border-b border-brown-200 pb-4"
                    >
                      <dt className="w-full sm:w-1/3 font-serif font-semibold text-brown-600 mb-2 sm:mb-0">
                        {item.label}
                      </dt>
                      <dd className="w-full sm:w-2/3 font-serif text-brown-500">
                        {item.value}
                      </dd>
                    </div>
                  ))}
                </div>
              </div>

              {/* Map */}
              <div>
                <h2 className="text-3xl md:text-4xl font-serif font-semibold text-brown-600 mb-8">
                  アクセス
                </h2>
                <div className="w-full h-[500px] rounded-xl overflow-hidden shadow-lg">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d52634.64842229488!2d133.89234!3d34.66167!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x355402e2b2c1c7e7%3A0x4061fd7e4e4e4e4e!2z5bKh5bGx5biC!5e0!3m2!1sja!2sjp!4v1234567890"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="ジュエリーおかやま株式会社の地図"
                  ></iframe>
                </div>
                
                <div className="mt-8 space-y-4">
                  <div className="flex items-start space-x-3">
                    <i className="ri-train-line text-2xl text-brown-400 flex-shrink-0 w-8 h-8 flex items-center justify-center"></i>
                    <div>
                      <h4 className="font-serif font-semibold text-brown-600 mb-1">電車でお越しの方</h4>
                      <p className="text-sm text-brown-500 font-serif">
                        JR岡山駅より徒歩15分
                      </p>
                    </div>
                  </div>
                  
                  <div className="flex items-start space-x-3">
                    <i className="ri-car-line text-2xl text-brown-400 flex-shrink-0 w-8 h-8 flex items-center justify-center"></i>
                    <div>
                      <h4 className="font-serif font-semibold text-brown-600 mb-1">お車でお越しの方</h4>
                      <p className="text-sm text-brown-500 font-serif">
                        岡山ICより約20分<br />
                        駐車場：店舗前に3台完備
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* History Section */}
        <section className="py-20 lg:py-28 bg-cream-100">
          <div className="max-w-[1000px] mx-auto px-6 lg:px-12">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-semibold text-center text-brown-600 mb-16">
              沿革
            </h2>
            
            <div className="space-y-8">
              {[
                { year: '2000年', event: 'ジュエリーおかやま株式会社を岡山市北区に設立' },
                { year: '2005年', event: 'オーダーメイドジュエリー部門を強化、専属デザイナーを採用' },
                { year: '2010年', event: 'ブライダルジュエリー専門コーナーを新設' },
                { year: '2015年', event: 'リメイク・修理サービスを本格的に開始' },
                { year: '2020年', event: '創業20周年を迎える。地域密着型サービスをさらに充実' },
                { year: '2025年', event: 'オンライン相談サービスを開始、より多くのお客様にご利用いただけるように' },
              ].map((item, index) => (
                <article key={index} className="flex items-start space-x-6">
                  <div className="flex-shrink-0 relative">
                    <div className="w-4 h-4 rounded-full bg-brown-400"></div>
                    {index !== 5 && (
                      <div className="absolute top-4 left-1/2 -translate-x-1/2 w-0.5 h-16 bg-brown-200"></div>
                    )}
                  </div>
                  <div className="flex-1 pb-8">
                    <time className="text-xl font-serif font-semibold text-brown-400 mb-2 block">
                      {item.year}
                    </time>
                    <p className="text-base text-brown-600 font-serif leading-relaxed">
                      {item.event}
                    </p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}